import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, unref as _unref, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8403f59a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["min", "max"]
const _hoisted_2 = { class: "flex items-center justify-between text-2xl" }
const _hoisted_3 = { class: "text-black font-bold range-lg" }

import { watch, ref, computed } from "vue";
import debounce from 'lodash.debounce';


export default /*#__PURE__*/_defineComponent({
  __name: 'SliderInput',
  props: {
    modelValue: Number,
    label: String,
    min: Number,
    max: Number
},
  emits: ['update:modelValue'],
  setup(__props, { emit }) {

const props = __props;





const value = ref(props.modelValue);

const emitValue = debounce(() => {
    emit('update:modelValue', value.value);
}, 200);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createElementVNode("input", {
      type: "range",
      min: __props.min,
      max: __props.max,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
      onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(emitValue) && _unref(emitValue)(...args))),
      class: "w-full h-2 bg-gray-200 cursor-pointer outline-none"
    }, null, 40, _hoisted_1), [
      [_vModelText, value.value]
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(__props.label), 1),
      _createElementVNode("span", null, _toDisplayString(value.value), 1)
    ])
  ]))
}
}

})